<div class="companies-page">
  <div class="title">
    <h2 class="vox-heading-2" translate>companies.title</h2>
  </div>
  <hr />
  <div class="companies-table-container">
    <div class="company-filters-container">
      <gdp-companies-table-filters (filtersChanged)="filterChanged($event)"
        [filters]="filters"></gdp-companies-table-filters>
    </div>
    <gdp-companies-table [companies]="companies" [loading]="loading"></gdp-companies-table>
    <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)"
      [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize">
    </gdp-table-pagination>
  </div>
</div>
